/* Account modal: header account icon / mobile menu "Account" link open it.
   Links keep their real href, so without JS they still go to Shopify's login / account page. */
(function () {
  'use strict';
  var modal = document.querySelector('[data-yc-account-modal]');
  if (!modal || typeof modal.showModal !== 'function') return;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-yc-account-open]');
    if (opener) {
      e.preventDefault();
      // close the mobile menu overlay if the link came from there
      var overlayClose = document.querySelector('[data-yc-menu-close]');
      if (opener.closest('.yc-menu-overlay') && overlayClose) overlayClose.click();
      modal.showModal();
      return;
    }
    if (e.target.closest('[data-yc-account-close]') && modal.open) modal.close();
  });

  // click on backdrop closes
  modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
})();
